module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-length/events-length.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-length/events-length.component.css
// module chunks = main